exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".c-partner-brand-displayer_auto-payment{background-color:#fff;color:#112363;font-weight:bold;padding:3px 9px;width:131px;margin:10px 0 4px}.c-partner-brand-displayer_auto-payment_icon{vertical-align:middle;margin-right:3px}.c-partner-brand-displayer_outstanding-bills{color:#d0021b;font-weight:bold;margin-top:10px}", ""]);

// exports
